import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
// import Todos from './views/Todos.vue'

import { userSession } from './userSession'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: (to, from, next) => {
        // console.log('Before route: Home. Checking production status.')
        // if (process.env.NODE_ENV === 'production') {
        //   console.log('Environment is production. Checking if user is signed in')
        //   if (userSession.isUserSignedIn()) {
        //     console.log('User signed in, forwarding to todos')
        //     next('/todos')
        //   }
        //   console.log('User is not signed in - forwarding to login')
        //   next('/login')
        // }
        // console.log('Ending beforeRoute routine for home')
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    // {
    //   path: '/about',
    //   name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // },
    {
      path: '/todos',
      name: 'todos',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Todos.vue')
    },
    {
      path: '*',
      component: () => import('./views/PageNotFound.vue')
    }
  ]
})
